import Icon from "components/Common/Icon";
import { getWowStatic } from "hooks/wow/getStaticData";
import React from "react";
import WowTooltip from "../Tooltips/WowTooltip";

const CraftedItem = ({ itemId }) => {
  const staticData = getWowStatic("item", itemId);

  return staticData ? (
    <WowTooltip type="item" id={itemId}>
      <Icon staticDataImg={staticData.img} iconSize="16px" />
    </WowTooltip>
  ) : null;
};

// Embellishment and missive reagent item ids arrive resolved in the builds
// payload (Common.EmbellishmentData in the exodia backend owns the bonus-ID
// mappings); this component just renders them.
const CraftedIcons = ({ embellishmentItemIds, missiveItemId }) => {
  const embellishments = embellishmentItemIds || [];

  return (
    <>
      {embellishments.length > 0 && (
        <div className="embellishments-container">
          {embellishments.map((itemId, index) => (
            <CraftedItem key={index} itemId={itemId} />
          ))}
        </div>
      )}
      {missiveItemId ? (
        <div className="missive-container">
          <CraftedItem itemId={missiveItemId} />
        </div>
      ) : null}
    </>
  );
};

export default CraftedIcons;
